// utils/userMenuData.js
import { PATHS } from "@/constants/pathnames";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const getUserMenuData = (t) => [
  {
    id: "profile",
    text: t("usermenu.profile"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["user"]} />,
    href: PATHS.PROFILE_PAGE.PATH,
    hideUserFlyOut: false,
  },
  {
    id: "trips",
    text: t("usermenu.mytrips"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["luggage"]} />,
    href: PATHS.TRAVELS_PAGE.PATH,
    hideUserFlyOut: false,
  },
  {
    id: "passengers",
    text: t("usermenu.passengers"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["identity-card"]} />,
    href: PATHS.PASSENGERS_PAGE.PATH,
    hideUserFlyOut: true,
  },
  {
    id: "saved-cards",
    text: t("usermenu.savedcards"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["credit-card"]} />,
    href: PATHS.SAVED_CARDS_PAGE.PATH,
    hideUserFlyOut: false,
  },
  {
    id: "points",
    text: t("usermenu.pointdetails"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["credit-card-coins"]} />,
    href: PATHS.POINT_DETAILS_PAGE.PATH,
    hideUserFlyOut: false,
  },
  {
    id: "invoices",
    text: t("usermenu.invoices"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["document"]} />,
    href: PATHS.INVOICE_PAGE.PATH,
    hideUserFlyOut: true,
  },
  {
    id: "alarms",
    text: t("usermenu.alarms"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["alarm-clock"]} />,
    href: PATHS.PRICE_ALARMS_PAGE.PATH,
    hideUserFlyOut: false,
  },
  {
    id: "favorites",
    text: t("usermenu.favorites"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["heart"]} />,
    href: PATHS.FAVORITES.PATH,
    hideUserFlyOut: false,
  },
  {
    id: "promotions",
    text: t("usermenu.promotions"),
    icon: <FontAwesomeIcon icon={byPrefixAndName.fak["tag"]} />,
    href: PATHS.PROMOTIONS_PAGE.PATH,
    hideUserFlyOut: false,
  },
];
